var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSwitchArrows = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 11,
    viewBox: "0 0 6 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.672.65c.157-.2.5-.2.656 0l2.603 3.317c.178.227-.01.533-.328.533H.397c-.318 0-.506-.306-.328-.533L2.672.65ZM3.328 10.35c-.157.2-.5.2-.656 0L.069 7.033C-.11 6.806.079 6.5.397 6.5h5.206c.318 0 .506.306.328.533L3.328 10.35Z",
    fill: "#787878"
  })));
};
export default SvgSwitchArrows;